<template>
  <div>
    <b-row>
      <b-col sm="12" md="9" class="p-3">
        <div class="align-middle" v-if="isShowChangePerPage">
          <span>จำนวน</span>
          <label class="d-inline-flex align-items-center">
            <b-form-select
              v-model="perPage"
              :options="paginationOptions.pageOptions"
              size="sm"
              class="ml-3"
            ></b-form-select>
          </label>
          <span class="ml-2">
            จากทั้งหมด {{ totalRecords | number("0,0") }} รายการ
          </span>
        </div>
      </b-col>
      <b-col sm="12" md="3" class="p-3">
        <b-input-group class="mt-3">
          <template #prepend>
            <b-input-group-text>
              <strong><i class="fas fa-search"></i></strong>
            </b-input-group-text>
          </template>
          <b-form-input placeholder="ค้นหา" v-model="search"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-table
          class="table table-centered table-nowrap"
          :items="items"
          :fields="fields"
          :show-empty="
            items === null ||
            items === undefined ||
            (items && items.length === 0)
          "
          empty-text="ไม่พบข้อมูล"
          responsive
          align="center"
          v-bind="$attrs"
          :filter="search"
          v-on="$listeners"
          :search="search"
          :bordered="true"
        >
          <template v-slot:cell(index)="data">
            <div class="text-right">
              {{ (firstRowOnPage + data.index) | number }}
            </div>
          </template>
          <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
            <slot :name="name" v-bind="data"></slot>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-if="isShowPagination">
      <b-col sm="12" md="6" class="mb-2">
        <div style="position: relative; top: 7px">
          รายการที่ {{ firstRowOnPage | number }} -
          {{ lastRowOnPage | number }} จากทั้งหมด
          {{ totalRecords | number("0,0") }} รายการ
        </div>
      </b-col>
      <b-col sm="12" md="6" class="mb-2">
        <b-pagination
          :total-rows="totalRecords"
          :per-page="perPage"
          v-model="pageNo"
          class="pagination pagination-rounded justify-content-end mb-2"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "TableView",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    isShowChangePerPage: {
      type: Boolean,
      default: true,
    },
    isShowPagination: {
      type: Boolean,
      default: true,
    },
    paginationOptions: {
      type: Object,
      default: () => ({
        totalRecords: 0,
        perPage: 10,
        pageNo: 1,
        pageOptions: [10, 25, 50, 100],
      }),
    },
  },
  data() {
    return {
      search: "",
    };
  },
  methods: {},
  computed: {
    totalRecords() {
      if (!this.paginationOptions.totalRecords) {
        return this.items.length;
      }
      return this.paginationOptions.totalRecords;
    },
    firstRowOnPage() {
      if (this.items.length > 0) {
        return (this.pageNo - 1) * this.perPage + 1;
      }
      return 0;
    },
    lastRowOnPage() {
      return this.firstRowOnPage + this.items.length - 1;
    },
    perPage: {
      get() {
        return this.paginationOptions.perPage;
      },
      set(val) {
        this.$emit("ChangePerPage", val);
      },
    },
    pageNo: {
      get() {
        return this.paginationOptions.pageNo;
      },
      set(val) {
        this.$emit("ClickPagination", val);
      },
    },
  },
};
</script>

<style lang="css" scoped></style>
